import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7ec90c53"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.10.0_lodash@4.17.21_prettier@2.8.8_vue-tem_io6vpxdna7qy64cf5vmx6qecnq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports